
import HomeBanner from '../components/home-page/banner.jsx';
import HomePortfolio from '../components/ui-components/portfolio.jsx';
import GlobalFootprint from '../components/home-page/global-footprint.jsx';
import Web from '../components/home-page/web-2.0.jsx';
import OurTeamHome from '../components/home-page/our-team-home.jsx';
import WhoWeAre from '../components/home-page/who-we-are.jsx';
import HowCanWeHelp from '../components/home-page/how-can-we-help.jsx';
import HomeArticlesList from '../components/articles/home-articles-list.jsx';
// import SeoHead from '../components/SeoHead.jsx';
const HomePage = ({ lang }) => {
  return (
    <>
    {/* <SeoHead slug="home" lang={lang} /> */}
      
      <HomeBanner lang={lang} />
   <WhoWeAre lang={lang} />
   <Web lang={lang} />
   <OurTeamHome lang={lang} />
   <GlobalFootprint  lang={lang}/>
   <HomePortfolio lang={lang} limit={12}  showLink={true}/>
    {/* <HomeArticlesList lang={lang} /> */}
   <HowCanWeHelp lang={lang}/>
  
  
    </>
  );
};

export default HomePage;